import { Component, Input, OnInit, inject } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { Observable } from 'rxjs';
import { map, startWith } from 'rxjs/operators';
import { ConstructAPI } from 'src/app/API/constructAPI';
import { RestApiService } from 'src/app/API/restapi';
import { SharedService } from 'src/app/Shared/shared-service.service';
import { Company } from 'src/model/company.model';
import { Customer } from 'src/model/customer.model';
import { CompanyService } from 'src/services/company.service';

@Component({
    selector: 'app-add-pulled-customer-record',
    templateUrl: './add-pulled-customer-record.component.html',
    styleUrls: ['./add-pulled-customer-record.component.scss'],
    standalone: false
})
export class AddPulledCustomerRecordComponent implements OnInit {
  private activeModal = inject(NgbActiveModal);
  private restapi = inject(RestApiService);
  private constructApi = inject(ConstructAPI);
  private sharedService = inject(SharedService);
  private companyService = inject(CompanyService);


  date: Date;
  remark: string;
  fromCompany: number;

  @Input() selectedCustomer: Customer;
  disabledSubmit = false;

  myControl = new UntypedFormControl();
  filteredCompany: Observable<Company[]>;

  companyList: Company[] = [];
  selectedCompanyCode: string;

  constructor() {

    //filter company
    this.filteredCompany = this.myControl.valueChanges.pipe(
      startWith(''),
      map(companyCode => this._filterCompanyCodeOptions(companyCode))
    );
  }

  ngOnInit(): void {
    this.getAllCompanies();
  }

  submit() {

    this.disabledSubmit = true;

    const data = {
      "fromCompany": this.fromCompany,
      "remark": this.remark,
      "date": this.date
    };

    const xhr = this.restapi.postRequest(this.constructApi.getAddPulledCustomerRecord(this.selectedCustomer.ID), data);
    xhr.onreadystatechange = () => {
      if (xhr.readyState == 4) {
        this.disabledSubmit = false;
        if (xhr.status == 200) {
          window.location.reload();
        } else
          this.sharedService.openErrorMessage(xhr);
      }

    }
  }

  private _filterCompanyCodeOptions(value: string): Company[] {
    const filterValue = value.toLowerCase();

    // return this.companyList.filter(company => company.CompanyCode.toLowerCase().includes(filterValue));
    // var filtered = this.companyList.filter(company => { return company.CompanyCode.toLowerCase().indexOf(filterValue) === 0 });
    const filtered = this.companyList.filter(company => { return company.CompanyCode.toLowerCase().includes(filterValue) });

    return filtered;
  }

  setSelectedCompanyCode(companyId: number) {
    const index = this.companyList.findIndex(company => Number(company.ID) == Number(companyId));
    this.selectedCompanyCode = this.companyList[index].CompanyCode;
  }

  setSelectedCompany(code: string) {

    const index = this.companyList.findIndex(company => company.CompanyCode.toLowerCase() == code.toLowerCase());
    this.fromCompany = this.companyList[index].ID;
  }

  async getAllCompanies() {
    this.companyList = await this.companyService.getAllCompanies();
    if (this.fromCompany != undefined) this.setSelectedCompanyCode(this.fromCompany);
  }

  reset() {
    this.activeModal.close();

  }
}
